import React, { Component } from "react";

import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CLabel
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

class LiterartePersonalCreateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      name: "",
      type: null,
      types: [],
      creating: false
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    axios
      .get(`${URL.api}literarte/text_types`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState({ types: resp.data.data, loading: false });
          } else {
            this.error("Não foi possível carregar os tipos de texto");
            this.setState({ loading: false });
          }
        },
        err => {
          this.error("Não foi possível carregar os tipos de texto");
          this.setState({ loading: false });
        }
      );
  }

  createTextProduction = () => {
    this.setState({ creating: true });

    let check = true;
    if (!this.state.name) {
      toastr.error("Erro", "O campo título não pode ser vazio.");
      check = false;
    }

    if (!this.state.type) {
      toastr.error("Erro", "O campo tipo não pode ser vazio.");
      check = false;
    }

    if (check) {
      let obj = {
        user_id: this.props.user.user.id,
        title: this.state.name,
        text_type_id: this.state.type,
        note: null,
        criterions: [],
        personal: true
      };

      axios
        .post(`${URL.api}literarte/activity_create`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            if (resp.data.success) {
              this.props.onClose();
            } else {
              this.error("Não foi possível criar a produção");
            }

            this.setState({ creating: false });
          },
          err => {
            this.error("Não foi possível criar a produção");
            this.setState({ creating: false });
          }
        );
    } else {
      this.setState({ creating: false });
    }
  };

  render() {
    return (
      <CModal size="md" show onClose={() => this.props.onClose()} centered>
        <CModalHeader closeButton>
          <CModalTitle className="d-inline-block mr-1">
            Criar produção
          </CModalTitle>
        </CModalHeader>
        <CModalBody style={{ maxHeight: "60vh", overflow: "auto" }}>
          {this.state.loading ? (
            <div className="d-flex p-4 justify-content-center">
              <Loading />
            </div>
          ) : (
            <>
              <FormGroup className="mb3">
                <CLabel>Título</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    value={this.state.name}
                    onChange={event =>
                      this.setState({ name: event.target.value })
                    }
                    placeholder="Título do texto"
                  />
                </InputGroup>
              </FormGroup>

              <FormGroup className="mb3">
                <CLabel>Tipo</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="select"
                    value={this.state.type}
                    onChange={e =>
                      this.setState({
                        type: parseInt(e.target.value)
                      })
                    }
                  >
                    <option value="">Escolha o tipo</option>
                    {this.state.types.map(type => (
                      <React.Fragment key={type.id}>
                        <option value={type.id}>{type.name}</option>
                      </React.Fragment>
                    ))}
                  </Input>
                </InputGroup>
              </FormGroup>
              <CButton
                color="primary"
                onClick={() => this.createTextProduction()}
                disabled={this.state.creating}
              >
                {this.state.creating ? "Criando..." : "Criar"}
              </CButton>
            </>
          )}
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiterartePersonalCreateModal);
